import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CheckBoxField from "../../../../shared/form/CheckBoxField";
import React from "react";

const SchoolTrainingCategoriesListing = ({categories, type, setSelectedCategoriesHandler} : any) => {

    return (
        <>
            {categories.map((category: any, index: any) => (
                <Box key={index} mb={2}>
                    <Typography variant="h4">
                        {category.name}
                    </Typography>
                    {category.subcategories?.length === 0 ? (
                        <Typography>Nu sunt itemi pentru selecția
                            curentă. {type === "training" && "Modifică nivelul de dificultate și încearcă din nou."}</Typography>
                    ) : (
                        <CheckBoxField
                            name="chapters"
                            type="checkbox-group"
                            label="Alege capitolele"
                            labelPlacement="end"
                            options={category.subcategories?.map(
                                (item: { name: string; id: string; [key: string]: any }) => {
                                    return {
                                        disabled: type === "literacy",
                                        label: item.name,
                                        value: item.id.toString(),
                                        checked: type === "literacy",
                                        ...item,
                                    };
                                },
                            )}
                            onChange={(e) => setSelectedCategoriesHandler(e, index)}
                        />
                    )}
                </Box>
            ))}
        </>
    )
}

export default SchoolTrainingCategoriesListing;